import { FC } from "react";

import { PortalTopBanners } from "@/components/Interface/Alert/PortalTopBanners";
import { Background } from "@/components/Layout/Background/Background";
import { Footer } from "@/components/Layout/Footer/Footer";
import { WelcomeContent } from "@/components/Welcome/WelcomeContent/WelcomeContent";
import { WelcomeHeader } from "@/components/Welcome/WelcomeHeader/WelcomeHeader";

export const Welcome: FC = () => (
  <Background>
    <PortalTopBanners placement="welcome" className="z-40" />
    <WelcomeHeader />
    <WelcomeContent />
    <Footer className="welcome-screen" />
  </Background>
);
